// @ts-check
import React from 'react'
import RootLayout from './src/components/root-layout'

/** @type {import('gatsby').GatsbyBrowser['wrapPageElement']} */
export const wrapPageElement  = ({ element, props }) => {
  return <RootLayout element={element} {...props}/>
}
